import Vue from 'vue'
import reviewsListConfig, { RelatedReviewsDisplayTypes } from './reviews-list-widget.config'
import reviewsStore from 'store/reviews-store'
import RelatedReviewsList from 'components/reviews-list/related-reviews-list'
import ReviewsList from 'components/reviews-list/reviews-list'
import globalStore, { Store } from 'init/global-store'
import UserToolbar from 'components/user-toolbar/user-toolbar'

import withRender from './reviews-list-widget.html'
import './reviews-list-widget.scss'

export default withRender(Vue.extend({
  data() {
    return {
      reviewsStore,
      globalStore
    }
  },
  components: {
    'tt-related-reviews-list': RelatedReviewsList,
    'tt-reviews-list': ReviewsList,
    'tt-user-toolbar': UserToolbar
  },
  computed: {
    currentSku(): string {
      return (this.globalStore as Store).sku
    },
    showRelatedList() {
      return reviewsListConfig.relatedReviewsDisplay === RelatedReviewsDisplayTypes.SEPARATE
    },
    showUserToolbar() {
      return reviewsListConfig.displayUserToolbar
    },
    showSearchResults() {
      return this.reviewsStore.searchTerm
    }
  },
  methods: {
    openMediaModal(media, startingIndex = 0) {
      // tslint:disable-next-line
      import(/* webpackChunkName: 'media-modal' */ 'components/media-modal/media-modal-loader').then((mediaModalLoader) => {
        mediaModalLoader.default.load({ media, startingIndex })
      })
    }
  },
  created() {
    // used by both direct and related reviews lists, so setting here
    reviewsStore.sort = reviewsListConfig.defaultSortOption
  }
}))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/widgets/reviews-list/reviews-list-widget.ts